import InfoIcon from '@mui/icons-material/Info'
import { Box, Typography } from 'src/components/UI'
import useStyles from '../styles'

const Alert = ({ text, warningText }: { text: string, warningText?: string }) => {
  const styles = useStyles()

  return (
    <Box className={styles.alertContainer}>
      <InfoIcon style={{ width: '24px', height: '24px' }} />
      <Typography className={styles.alertText}>
        {text}
        {warningText && (
          <Typography className={styles.warningText}>
            {warningText}
          </Typography>
        )}
      </Typography>
    </Box>
  )
}

export default Alert
